import { render, staticRenderFns } from "./MedicalSpecialityAddModal.vue?vue&type=template&id=abf471a8"
import script from "./MedicalSpecialityAddModal.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialityAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports